import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import "colbi_web_ui/lib/style/variableInjector.scss";
import "colbi_web_ui/lib/style/index.sass";
import "mosaic-react/installLicense";

import "./polyfills/object.entries.js";

import React from "react";
import ReactDOM from "react-dom/client";

import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";

import CheckPermissionsRouting from "./components/CheckPermissionsRouting";
import configureStore from "./store";
import { fetchAction } from "./store/actions";
import * as serviceWorker from "./serviceWorker";
import HeadChange from "./components/HeadChange.js";
import { AuthProvider } from "react-oidc-context";
import { AUTH_CONFIG } from "./environmentVariables.js";

export const { store, persistor } = configureStore({});

const oidcConfig = {
    ...AUTH_CONFIG,
    onSigninCallback() {
        // You must provide an implementation of onSigninCallback to oidcConfig to remove the payload
        // from the URL upon successful login.
        // Otherwise if you refresh the page and the payload is still there, signinSilent - which handles renewing your token - won't work.

        window.history.replaceState({}, document.title, window.location.pathname);
    },
};

ReactDOM.createRoot(document.getElementById("root")).render(
    <AuthProvider {...oidcConfig}>
        <Provider store={store}>
                <Router>
                    <HeadChange />
                    <CheckPermissionsRouting store={store} fetchAction={fetchAction} />
                </Router>
        </Provider>
    </AuthProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
